import React from 'react';
import { styled } from 'linaria/react';
import { Typography } from 'fronton-react';
import { InfoIcon } from '@fronton/icons-react';

export const Infobar = () => (
  <InfobarContainer>
    <ParagraphContainer>
      <InfoIcon type="outline" size="l" color="text-primary" />
      <Typography size="body_long" variant="s">
        От выбора материала поверхости зависит расход товара
      </Typography>
    </ParagraphContainer>
  </InfobarContainer>
);

const InfobarContainer = styled.div`
  display: flex;
  padding: 16px;
  background: var(--background-secondary);
  border-radius: var(--rounding-l);
`;

const ParagraphContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
